import React, { ReactNode, useEffect, useRef } from 'react';

import { motion, useAnimation, useInView } from 'framer-motion';

const staggerTabVariants = {
  active: {
    transition: {
      staggerChildren: 0.2,
      delay: 0.2,
    },
  },
  inactive: {},
};

export const StaggerTabContent = ({ isActive, children }: { isActive: boolean; children: ReactNode }) => {
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.2, once: true });

  useEffect(() => {
    if (isInView && isActive) {
      controls.start('active');
    } else {
      controls.start('inactive');
    }
  }, [isInView, isActive, controls]);

  return (
    <motion.div
      ref={ref}
      role="tabpanel"
      style={{
        display: isActive ? 'block' : 'none',
      }}
      variants={staggerTabVariants}
      initial={'inactive'}
      animate={controls}
    >
      {children}
    </motion.div>
  );
};
